(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  const initializeFeaturedCollectionPagination = (container) => {
    const sliderComponent = container.querySelector('slider-component');
    const slider = sliderComponent?.querySelector('ul[id^="Slider-"]');
    const slides = slider
      ? Array.from(slider.children).filter((slide) => slide.matches('li[id^="Slide-"]'))
      : [];
    const dotsContainer = container.querySelector('[id^="Slider-Dots-"]');
    const currentElement = container.querySelector('.slider-counter--current');
    const totalElement = container.querySelector('.slider-counter--total');

    if (!slider || slides.length === 0 || (!dotsContainer && !currentElement && !totalElement)) return;
    if (slider.dataset.featuredCollectionPagination === 'true') return;

    slider.dataset.featuredCollectionPagination = 'true';

    let slideOffset = 0;
    let totalPages = 1;

    const setActivePage = (pageIndex) => {
      const activePage = Math.max(0, Math.min(pageIndex, totalPages - 1));

      if (currentElement) currentElement.textContent = activePage + 1;

      if (dotsContainer) {
        dotsContainer.querySelectorAll('.dot').forEach((dot, index) => {
          const isActive = index === activePage;
          dot.classList.toggle('active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }
    };

    const updatePagination = () => {
      if (slideOffset <= 0) return;
      setActivePage(Math.round(slider.scrollLeft / slideOffset));
    };

    const goToPage = (pageIndex) => {
      if (slideOffset <= 0) return;
      setActivePage(pageIndex);
      slider.scrollTo({ left: pageIndex * slideOffset });
    };

    const renderPagination = () => {
      const visibleSlides = slides.filter((slide) => slide.clientWidth > 0);
      if (visibleSlides.length === 0) return;

      slideOffset =
        visibleSlides.length > 1
          ? visibleSlides[1].offsetLeft - visibleSlides[0].offsetLeft
          : visibleSlides[0].clientWidth;

      if (slideOffset <= 0) return;

      const slidesPerPage = Math.max(
        1,
        Math.floor((slider.clientWidth - visibleSlides[0].offsetLeft) / slideOffset)
      );
      totalPages = Math.max(1, visibleSlides.length - slidesPerPage + 1);

      if (totalElement) totalElement.textContent = totalPages;

      if (dotsContainer) {
        dotsContainer.replaceChildren();

        for (let index = 0; index < totalPages; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'dot';
          dot.setAttribute('aria-label', String(index + 1));
          dot.setAttribute('aria-controls', slider.id);
          dot.addEventListener('click', () => goToPage(index));
          dotsContainer.appendChild(dot);
        }
      }

      updatePagination();
    };

    slider.addEventListener('scroll', updatePagination, { passive: true });
    renderPagination();

    if ('ResizeObserver' in window) {
      new ResizeObserver(renderPagination).observe(slider);
    } else {
      window.addEventListener('resize', renderPagination);
    }
  };

  const initializeFeaturedCollectionSections = (root) => {
    const containers = root.matches?.('.collection[id^="collection-"][data-id]')
      ? [root]
      : Array.from(root.querySelectorAll('.collection[id^="collection-"][data-id]'));

    containers.forEach(initializeFeaturedCollectionPagination);
  };

  initializeFeaturedCollectionSections(document);
  document.addEventListener('shopify:section:load', (event) => {
    initializeFeaturedCollectionSections(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
